namespace TabAurous.Common {
    export interface VoucherWithIssues extends Serenity.ServiceResponse {
        VoucherNo?: string;
        Issues?: Issue[];
    }
}
